import {TourSteps} from './interface/tour-steps.interface';
import Step from 'shepherd.js/src/types/step';
import {firstValueFrom} from 'rxjs';
import {PanelUtilitiesActions} from '../../../models/panel-utilities';

export const startAdviceStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons, services}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'advice1',
        title: 'Asesoría',
        text: 'Para realizar este tour crearemos una cita de prueba, al final del tour esta cita será eliminada. Da clic en la cita para continuar.',
        attachTo: {
          element: '.shepherd-appointment-demo',
          on: 'top',
        },
        scrollTo: null,
        advanceOn: {
          selector: '.shepherd-appointment-demo',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
        beforeShowPromise: async () => {
          return new Promise((resolve): void => {
            services.utilitiesService.existElementInDom().byClassName('shepherd-appointment-demo').subscribe({
              next: async () => {
                await firstValueFrom(services.store.dispatch(new PanelUtilitiesActions.SetIsVisible(false)));
              },
              complete: async () => {
                await firstValueFrom(services.store.dispatch(new PanelUtilitiesActions.SetIsVisible(true)));
                resolve(true);
              },
            });
          });

        }
      },

      {
        ...steps.default,
        id: 'advice2',
        title: 'Acciones de cita',
        text: 'Estos botones pueden variar dependiendo del estatus de la cita.',
        attachTo: {
          element: 'app-user-info .shepherd-appointment-btn-actions',
          on: 'bottom',
        },
        canClickTarget: false,
        // Dividir el tour
        beforeShowPromise: () => {
          return new Promise(async (resolve): Promise<void> => {
            await firstValueFrom(services.store.dispatch(new PanelUtilitiesActions.SetIsVisible(false)));
            services.utilitiesService.existElementInDom().byId('shepherd-appointment-btn-actions').subscribe({
              complete: (): void => {
                resolve(true);
              }
            });
          });
        },
      },
      {
        ...steps.default,
        id: 'advice3',
        title: 'Cancelar cita',
        text: 'Si presionas este botón cancelarás la cita y el horario volverá a a estar disponible para agendar una nueva cita.',
        attachTo: {
          element: 'app-user-info .cancel-appointment-button',
          on: 'bottom',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice4',
        title: 'Reprogramar cita',
        text: 'Si requieres reprogramar la cita para otro día u hora, lo podrás hacer mediante este botón.',
        attachTo: {
          element: 'app-user-info .reschedule-appointment-button',
          on: 'bottom',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice5',
        title: 'Iniciar la cita',
        text: 'Inicia la asesoría para un paciente.',
        attachTo: {
          element: 'app-user-info .shepherd-btn-start-appointment',
          on: 'bottom',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice6',
        title: 'Información de la cita',
        text: 'En esta sección podrás visualizar datos acerca de la cita.',
        attachTo: {
          element: 'app-user-info .container-indicators',    // @ts-ignore
          on: 'bottom',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice7',
        title: 'Información del paciente',
        text: 'En esta sección podrás visualizar datos básicos del paciente. Durante la asesoría podrás editar esta información.',
        attachTo: {
          element: '.shepherd-patient-basic-information',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice8',
        title: 'Objetivos clínicos',
        text: 'En esta sección podrás visualizar los objetivos de la cita y objetivos finales, además del motivo por el cual se programó la cita.',
        attachTo: {
          element: '.shepherd-clinic-objectives',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice9',
        title: 'Objetivos clínicos',
        text: 'En esta sección podrás visualizar las mediciones que se han registrado del paciente. Para fines del tour, se han agregado algunas mediciones.',
        attachTo: {
          element: 'app-all-measurements-table',    // @ts-ignore
          on: 'top',
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'advice10',
        title: 'Iniciar cita',
        text: 'Presiona sobre el botón "INICIAR LA CITA" para comenzar con la asesoría.',
        attachTo: {
          element: '.shepherd-btn-start-appointment',
          on: 'bottom',
        },
        advanceOn: {
          selector: '.shepherd-btn-start-appointment',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      }
    ];
  };
